const Modal = ({ children }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-[3px] bg-black bg-opacity-20">
      <div className="bg-white rounded-xl shadow-xl lg:w-[60%] xl:w-[50%] w-full sm:m-10 m-5">
        {children}
      </div>
    </div>
  );
};

export default Modal;
